// extracted by mini-css-extract-plugin
export default {"content":"AccountDetailsRow_content__GSEdf","content__row":"AccountDetailsRow_content__row__98sxs"};